import React from 'react';
import './index.less';

function GenderData({ image, value, title }) {
	return (
		<div className='analytics-diagram-data'>
			<div className={image} />
			<div className='analytics-diagram-info'>
				<div className='analytics-diagram-value font-proxima-nova-bold'>
					{value || 0}
				</div>
				<div className='analytics-diagram-title'>
					{title}
				</div>
			</div>
		</div>
	);
}

export default GenderData;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/Diagram/GenderData/index.js